/*eslint  @typescript-eslint/no-use-before-define: 0*/

import _ from "lodash";
import { DataOptions } from "vuetify";
import { defineModule } from "direct-vuex";
import { FILTER_NAMES } from "@/static/filterNames";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { OrderToMerge, OrderToMergeResponse } from "@/models/api/orders/OrdersToMerge";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { getOrdersToMerge, mergeOrders } from "@/requests/order/order";

export interface OrderMergeStateInterface {
  orderId: string | null;
  isMergeLoading: boolean;
  mergeFilters: Array<CriterionItemRequest> | null;
  mergeOptions: DataOptions;
  mergeCount: number;
  mergeItems: Array<OrderToMerge>;
  ordersToMerge: Array<OrderToMerge>;
}

export const OrderMergeState: OrderMergeStateInterface = {
  orderId: null,
  isMergeLoading: false,
  mergeFilters: null,
  mergeOptions: new DefaultDataOptions(),
  mergeCount: 0,
  mergeItems: [],
  ordersToMerge: [],
};

const OrderMergeModule = defineModule({
  state: OrderMergeState as OrderMergeStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setOrderId(state, param: string | null) {
      state.orderId = param;
    },
    setIsMergeLoading(state, param: boolean) {
      state.isMergeLoading = param;
    },
    setMergeFilters(state, param: Array<CriterionItemRequest>) {
      state.mergeFilters = param;
    },
    setMergeOptions(state, param: DataOptions) {
      state.mergeOptions = param;
    },
    setMergeItems(state, param: OrderToMergeResponse) {
      state.mergeCount = param.totalCount;
      state.mergeItems = param.items;
    },
    setOrdersToMerge(state, param: Array<OrderToMerge>) {
      state.ordersToMerge = param;
    },
  },
  actions: {
    async downloadOrdersToMerge(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.orderId !== null) {
        commit.setIsMergeLoading(true);
        const response = await getOrdersToMerge(state.orderId, {
          count: state.mergeOptions.itemsPerPage,
          page: state.mergeOptions.page - 1,
          criterions: _.cloneDeep(state.mergeFilters),
          filterName: FILTER_NAMES.OrdersFilter,
        });
        commit.setMergeItems(response);
        commit.setIsMergeLoading(false);
      }
    },
    async mergeOrders(context) {
      const { state, rootDispatch, commit } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      if (state.orderId !== null && state.ordersToMerge.length > 0) {
        const orders = state.ordersToMerge.map((item) => item.id);
        await mergeOrders(state.orderId, orders);
        await rootDispatch.popup.addSavedOkSnackbar();
        await rootDispatch.orders.getOrdersTable();
        commit.setOrdersToMerge([]);
        commit.setOrderId(null);
      } else await rootDispatch.popup.addFormErrorsSnackbar();
    },
  },
});

export default OrderMergeModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, OrderMergeModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, OrderMergeModule);
